<div class="homepage-welcome-title">
  <h1>Bergführerverein Matrei in Osttirol</h1>
</div>
<div id="tariffs" class="container tariffs-container">
  <h1 class="tariffs-title">Unsere Tarife <i style="margin-left: 1rem" class="fas fa-info"></i></h1>
  <div class="row tariffs">
    <div class="col-md-6">
      <div class="tariffs-icon-container">
        <div class="hover-div" (click)="showModal(tariffsType.summer)">
          <span class="tariffs-icon-summer"><i class="fas fa-sun"></i></span>
          <h3 class="tariffs-label"><b>Sommer Tarife</b></h3>
        </div>
        <p class="tariffs-text">
          Holen Sie sich jetzt alle Informationen für unsere Sommer Touren!
        </p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="tariffs-icon-container">
        <div class="hover-div" (click)="showModal(tariffsType.winter)">
          <span class="tariffs-icon-winter"><i class="fas fa-skiing-nordic"></i></span>
          <h3 class="tariffs-label"><b>Winter Tarife</b></h3>
        </div>
        <p class="tariffs-text">
          Holen Sie sich jetzt alle Informationen für unsere Winter Touren!
        </p>
      </div>
    </div>
  </div>
</div>
<p-dialog
  [(visible)]="dialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [blockScroll]="true"
  [appendTo]="'body'"
  [baseZIndex]="11000"
  [style]="{ width: '85vw', maxWidth: '1200px' }"
  [contentStyle]="{ padding: '0.5rem' }"
  [header]="currentTariffType === tariffsType.summer ? 'Sommer Tarife' : 'Winter Tarife'">
  <div style="position: relative">
    <iframe [src]="currentPdfSafeUrl" width="100%" height="700" [title]="currentTariffType === tariffsType.summer ? 'Sommer Tarife' : 'Winter Tarife'"></iframe>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
    <button type="button" class="btn btn-primary" (click)="downloadPDF(currentTariffType)">Download</button>
  </ng-template>
</p-dialog>
<div class="decorator"></div>
